import React from 'react';
import styled from 'styled-components';
import { orderBy } from 'lodash';
import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Container } from 'components/basics';
import { colors } from 'styles';
import PlansTableBlock from './PlansTable/PlansTable';

const DetailedPlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5em;
`;

const Title = styled(Typography)`
  color: ${colors.purple};
  text-align: center;
`;

const DetailedPlansBlock = ({ isMonthlySelected, plans }) => {
  const getRows = (header = false) => {
    const orderedPlans = orderBy(plans, p => p.frontmatter.index);
    let rows = [];
    const planNames = orderedPlans.map(({ frontmatter: plan }) => plan.name);

    Object.keys(plans[0].frontmatter).forEach(plan => {
      let plansObj = { legend: plan };
      planNames.map(p => {
        plansObj = {
          ...plansObj,
          // eslint-disable-next-line standard/computed-property-even-spacing
          [p]: plans.find(({ frontmatter: pl }) => pl.name === p).frontmatter[
            plan
          ],
        };
      });
      rows = [...rows, plansObj];
    });
    const headerRows = rows.slice(1, 6);
    const bodyRows = rows.slice(5 + 1);

    let headerCells = [];

    planNames.map(plan => {
      let planHeader = {};
      headerRows.map(row => {
        planHeader = { ...planHeader, [row.legend]: row[plan] };
      });
      headerCells = [...headerCells, planHeader];
    });

    if (isMonthlySelected) {
      bodyRows.shift();
    } else {
      bodyRows.splice(1, 1);
    }

    if (header) {
      return headerCells;
    }
    return bodyRows;
  };

  return (
    <DetailedPlansContainer id="detailedPlansContainer">
      <Title variant="h4">
        <FormattedMessage id="pricing.inDetails" />
      </Title>
      <PlansTableBlock
        headerCells={getRows(true)}
        bodyRows={getRows()}
        isMonthlySelected={isMonthlySelected}
      />
    </DetailedPlansContainer>
  );
};

export default DetailedPlansBlock;
